import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import useAppSelector from 'packages/hooks/use-app-selector';
import {selectTournament} from 'redux/features/app-slice';
import {selectRoundMetadata} from 'redux/features/round-slice';
import useCommonStyles from '../../common-utils/common-styles';
import useStyles from '../admin-styles';

const SubHeader = () => {
  const classes = useStyles();
  const common = useCommonStyles();
  const selectedTournament = useAppSelector(selectTournament);
  const {currentRound, nextRound} = useAppSelector(selectRoundMetadata);

  const renderCurrentRound = () => {
    let roundToDisplay = '--';

    const roundLimit = selectedTournament?.conditions.numberOfRounds;
    if (selectedTournament) {
      roundToDisplay =
        nextRound < roundLimit ? `${currentRound}` : `Ronda final`;
    }

    return (
      <Typography component="span" color="primary" variant="subtitle2">
        {roundToDisplay}
      </Typography>
    );
  };

  return (
    <aside className={clsx([classes.sh_root, common.default_padding])}>
      <span className={classes.sh_label}>
        Ronda jugando:{' '}
        <Typography component="span" color="primary" variant="subtitle2">
          {renderCurrentRound()}
        </Typography>
      </span>
      <span className={classes.sh_label}>
        Siguiente ronda:{' '}
        <Typography component="span" color="primary" variant="subtitle2">
          {nextRound <= selectedTournament?.conditions.numberOfRounds
            ? nextRound
            : '--'}
        </Typography>
      </span>
      <span className={classes.sh_label}>
        Número de rondas:{' '}
        <Typography component="span" color="primary" variant="subtitle2">
          {selectedTournament?.conditions.numberOfRounds}
        </Typography>
      </span>
      <span className={classes.sh_label}>
        Torneo seleccionado:{' '}
        {selectedTournament ? (
          <Typography component="span" color="primary" variant="subtitle2">
            {`${selectedTournament.name}:${selectedTournament.conditions.modalityGame}`}
          </Typography>
        ) : (
          '---'
        )}
      </span>
    </aside>
  );
};

export default SubHeader;
